// extracted by mini-css-extract-plugin
module.exports = {"partners":"Partners_partners__1LsIj","partners__logos":"Partners_partners__logos__3RW-a"};